"use client"

// I'm not sure if we're going to keep this change or not, so I'm commenting this
// whole class out to make it super easy to revert.

// import VideoPlayer from "components/Landing/VideoPlayer"

// import { Box, H2 } from "@bullseye/components"

// type Props = {
//   videoId: string
//   copy: {
//     title: string
//     description?: string
//   }
// }

// const VideoHero = ({ copy, videoId }: Props) => {
//   return (
//     <Box className="bg-primary-50 py-16 md:py-20">
//       <H2 className="text-center font-bold">{copy.title}</H2>
//       <Box className="mx-auto my-0 w-full max-w-[800px] pt-10">
//         <VideoPlayer url={`https://support.wistia.com/medias/${videoId}`} />
//       </Box>
//     </Box>
//   )
// }
import { Box } from "@bullseye/components"

const VideoHero = () => {
  return <Box className="bg-primary-50 py-8"></Box>
}

export default VideoHero
